import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import PinDialog from '../../parts/PinDialog.vue';
import MessageModule from '../../mixins/MessageModule';
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
export default Vue.extend({
    mixins: [MessageModule],
    components: { ToolBar, PinDialog },
    name: "SettingsTop",
    data() {
        return {
            showPinDialog: false,
        };
    },
    methods: {
        showNotImplementedYet() {
            this.showError(this.$t('common.coming_soon').toString());
        },
        changePassword() {
            this.showPinDialog = true;
        },
        goToSecurityLesson() {
            this.$store.commit(MUTATION_TYPES.SET_BACK_PATH_FROM_LESSON, '/settings/top');
            this.$router.push('/lesson/introduction');
        },
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/settings/SettingsTop.vue
// module id = 660
// module chunks = 1